export const WASTE_WARNING_THRESHOLD_PERCENT = 10

export function calculateActualWastePercent(used, disposed) {
    const u = parseFloat(used) || 0
    const d = parseFloat(disposed) || 0
    const total = u + d
    if (total <= 0) return null
    return (d / total) * 100
}

export function calculateIngredientWaste(lotIngredient, usageData) {
    let totalUsed = 0
    let totalDisposed = 0

    if (lotIngredient.inventory_allocations) {
        for (const allocation of lotIngredient.inventory_allocations) {
            const usage = usageData[allocation._id]
            if (usage) {
                totalUsed += parseFloat(usage.quantity_used) || 0
                totalDisposed += parseFloat(usage.quantity_disposed) || 0
            }
        }
    }

    const actualWastePercent = calculateActualWastePercent(totalUsed, totalDisposed)
    const expectedWastePercent = lotIngredient.recipe_ingredient_data?.waste_percentage != null
        ? parseFloat(lotIngredient.recipe_ingredient_data.waste_percentage)
        : null

    return { actualWastePercent, expectedWastePercent, totalUsed, totalDisposed }
}


export function getWasteColor(pct) {
    const val = Math.abs(parseFloat(pct))
    if (isNaN(val)) return ''
    if (val < 3) return 'text-success'
    if (val <= 5) return 'text-warning'
    return 'text-danger'
}

export function getWasteBadgeVariant(pct) {
    const val = Math.abs(parseFloat(pct))
    if (isNaN(val)) return 'secondary'
    if (val < 3) return 'success'
    if (val <= 5) return 'warning'
    return 'danger'
}

export function isExcessiveWaste(actualPercent, threshold) {
    return actualPercent !== null && actualPercent > threshold
}
